module.exports = __webpack_public_path__ + "img/imagem-detalhada-palmeiras-01.92bee525.png";